import { render, staticRenderFns } from "./SelectTemplateCategory.vue?vue&type=template&id=ffed5c12&lang=pug"
import script from "./SelectTemplateCategory.vue?vue&type=script&lang=js"
export * from "./SelectTemplateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports